import { ArrowLeft, FileSpreadsheet, Loader2 } from "lucide-react";

import { Button } from "components/ui/button";
import type { TaxClosingTabs } from "@/services/tax-closing";

import { useExcelDownload } from "../hooks/use-excel-download";
import { ReprocessOfmButton } from "./reprocess-ofm-button";

interface PageHeaderProps {
  jobId: string | undefined;
  summary: TaxClosingTabs["summary"] | undefined;
  hasData: boolean;
  onBack: () => void;
}

export function PageHeader({ jobId, summary, hasData, onBack }: PageHeaderProps) {
  const { exportExcel, downloading } = useExcelDownload(jobId);

  return (
    <div className="mb-6 w-full">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-start justify-start gap-4">
          <Button
            variant="outline"
            size="icon"
            className="h-9 w-9 shrink-0"
            onClick={onBack}
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">
              Dados do Fechamento Fiscal
            </h1>
            <HeaderSubtitle jobId={jobId} summary={summary} />
          </div>
        </div>

        <div className="flex items-center gap-2">
          <ReprocessOfmButton jobId={jobId} />
          <Button
            variant="outline"
            className="gap-2"
            disabled={!hasData || downloading}
            onClick={exportExcel}
          >
            {downloading ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <FileSpreadsheet className="h-4 w-4" />
            )}
            Exportar Excel
          </Button>
        </div>
      </div>
    </div>
  );
}

interface HeaderSubtitleProps {
  jobId: string | undefined;
  summary: TaxClosingTabs["summary"] | undefined;
}

function HeaderSubtitle({ jobId, summary }: HeaderSubtitleProps) {
  return (
    <p className="text-sm text-muted-foreground mt-0.5">
      Job ID: {jobId ?? "—"}
      {summary && (
        <>
          {" "}
          &middot;{" "}
          <span className="font-medium text-foreground">
            {summary.totalStores} lojas
          </span>{" "}
          &middot;{" "}
          <span className="font-medium text-foreground">
            {summary.totalNotes.toLocaleString("pt-BR")} notas
          </span>
        </>
      )}
    </p>
  );
}
